import type { ErrorType } from '~/data/ErrorRecord';
import BaseException from './BaseException';

const defaultError = {
  description: 'web.error.internal_error',
};

class UnknownException extends BaseException {
  readonly name = 'UnknownException';

  static from({
    description = 'web.error.internal_error',
    detail,
    status,
    id,
  }: ErrorType = defaultError) {
    return new UnknownException({
      errors: [
        {
          id,
          status,
          description,
          detail,
        },
      ],
    });
  }
}

export default UnknownException;
